import { connect } from 'react-redux';
import { TwoFactorWithPhoneViewContainer as Component } from './TwoFactorWithPhoneViewContainer';
export function mapStateToProps(state) {
  return {
    useSelector: function useSelector(fn) {
      return fn(state);
    }
  };
}
export function mapDispatchToProps(dispatch) {
  return {
    useDispatch: function useDispatch() {
      return dispatch;
    }
  };
}
export var TwoFactorWithPhoneViewContainer = connect(mapStateToProps, mapDispatchToProps)(Component);